(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cat"] && !Shopify.designMode) return;
  try {
    
  let currentSlide = 0;
  let visibleCards = getVisibleCards();

  function getVisibleCards() {
    const width = window.innerWidth;
    if (width <= 600) return 1;
    if (width <= 991) return 1;
    if (width <= 1030) return 2;
    if (width <= 1600) return 2;
    return 4; // for large screens
  }

  function updateSlider() {
    const activeSliderInner = document.querySelector('.tab-content.active .slider-inner');
    if (!activeSliderInner) return;

    visibleCards = getVisibleCards(); // update on every slide
    const totalCards = activeSliderInner.children.length;
    const maxSlide = Math.max(0, totalCards - visibleCards);
    currentSlide = Math.min(currentSlide, maxSlide);

    activeSliderInner.style.transform = `translateX(-${(100 / visibleCards) * currentSlide}%)`;
  }

  document.querySelector('.next-slide').addEventListener('click', () => {
    currentSlide++;
    updateSlider();
  });

  document.querySelector('.prev-slide').addEventListener('click', () => {
    currentSlide = Math.max(0, currentSlide - 1);
    updateSlider();
  });

  // Tab button click handler
  document.querySelectorAll('.tab-btn').forEach((btn, idx) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

      btn.classList.add('active');
      document.querySelector(`.tab-content[data-content="${idx}"]`).classList.add('active');

      currentSlide = 0;
      updateSlider();
    });
  });
// Its testing

  const slider = document.querySelector('.product-slider');
const nextBtn = document.querySelector('.next-btn');
const prevBtn = document.querySelector('.prev-btn');

const slideAmount = 270; // width + gap

nextBtn.addEventListener('click', () => {
  slider.scrollLeft += slideAmount;
});

prevBtn.addEventListener('click', () => {
  slider.scrollLeft -= slideAmount;
});

// SWIPE SUPPORT
let startX = 0;

slider.addEventListener('touchstart', (e) => {
  startX = e.touches[0].clientX;
});

slider.addEventListener('touchend', (e) => {
  const endX = e.changedTouches[0].clientX;
  const diffX = startX - endX;

  if (diffX > 50) {
    // Swipe left
    slider.scrollLeft += slideAmount;
  } else if (diffX < -50) {
    // Swipe right
    slider.scrollLeft -= slideAmount;
  }
});

  // Responsive adjustment on window resize
  window.addEventListener('resize', () => {
    updateSlider();
  });

  // Initial call
  updateSlider();
  // its testig

  } catch(e) { console.error(e); }
})();
})();
